import { render, staticRenderFns } from "./BaseTradeInSection.vue?vue&type=template&id=1e9c9fea&scoped=true"
import script from "./BaseTradeInSection.vue?vue&type=script&lang=js"
export * from "./BaseTradeInSection.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInSection.vue?vue&type=style&index=0&id=1e9c9fea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9c9fea",
  null
  
)

export default component.exports